import React from 'react';
import {IconTooltip, Text} from '@forecast-it/design-system';

export function DateRestrictionInfoIcon({message}: {message: string}): JSX.Element | null {
	return message ? (
		<IconTooltip icon={'info'} color={'disabled'} iconSize={'s'}>
			<Text size={'2'} color={'medium'}>
				{message}
			</Text>
		</IconTooltip>
	) : null;
}
